<!--<ak-message-box-->
<!--  [type]="data?.severity"-->
<!--  [showCloseButton]="data?.showCloseButton"-->
<!--  [actionButtonText]="data?.actionProps?.confirmText"-->
<!--  (onActionButtonClicked)="onActionButtonClick()"-->
<!--  (onMessageBoxClosed)="onCloseButtonClick()"-->
<!--&gt;-->
<!--  {{ data.bodyMessage }}-->
<!--</ak-message-box>-->
<div>{{ data.bodyMessage }}</div>

<button (click)="onCloseButtonClick()">X</button>
